/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Chat_Suggestions_Welcome_7Inputs */

const es_chat_suggestions_welcome_7 = /** @type {(inputs: Chat_Suggestions_Welcome_7Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hola ${i?.name}. Decime qué necesitás y lo vemos juntos.`)
};

const en_chat_suggestions_welcome_7 = /** @type {(inputs: Chat_Suggestions_Welcome_7Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hello ${i?.name}. Let me know what you need.`)
};

/**
* | output |
* | --- |
* | "Hello {name}. Let me know what you need." |
*
* @param {Chat_Suggestions_Welcome_7Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_suggestions_welcome_7 = /** @type {((inputs: Chat_Suggestions_Welcome_7Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Suggestions_Welcome_7Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_suggestions_welcome_7(inputs)
	return en_chat_suggestions_welcome_7(inputs)
});
export { chat_suggestions_welcome_7 as "chat.suggestions.welcome_7" }